module.exports = __webpack_public_path__ + "img/thumbs-up.88a2e8fd.png";